import { css } from '@emotion/react';
import { Theme } from '../../config/theme';

export default (theme: Theme) => ({
  modal: css`
    position: fixed;
    top: 0;
    right: 0;
    width: 100%;
    max-width: 600px;
    height: 100%;
    background-color: ${theme.color.primary};
    box-sizing: border-box;
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.15), 0px 4px 6px rgba(0, 0, 0, 0.1);
    transition: 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
  `,
  hideSidebar: css`
    transform: translate(100%, 0);
  `,
  showSidebar: css`
    transform: translate(0, 0);
  `,
  header: css`
    height: ${theme.fontLineHeight.large};
    padding: ${theme.spacing.standard};
    align-self: flex-end;
    display: flex;
  `,
  modalContent: css`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 90%;
    height: calc(100% - ${theme.fontLineHeight.large});
    margin-top: ${theme.spacing.large};
  `,
  blurOverlay: css`
    height: inherit;
    width: auto;
    padding: 0;
    margin: 0;
    background-color: ${theme.color.blurOverlay};
    transition: opacity 0.3s ease;
  `,
  showBlurOverlay: css`
    opacity: 1;
  `,
  hideBlurOverlay: css`
    opacity: 0;
  `,
});
